import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import PageWithBreadcrumbs from 'layouts/PageWithBreadcrumbs';
import { BEM_NAME_ELEMENTS, PAGE_ICONS, PAGE_ROUTES } from '../../_const';

/**
 * Breadcrumb navigation
 * @param {string} currentPageLabel
 * @param {ReactElement} CurrentPageIcon
 * @param {any} props
 * @returns {ReactElement} navigation breadcrumbs for User Access Review
 */
const NEPageWithBreadcrumbs = ({
	currentPageLabel = '',
	CurrentPageIcon = null,
	...props
}) => {
	const history = useHistory();

	const currentPageStyles = {
		display: 'flex',
		alignItems: 'center',
		cursor: 'default',
	};

	const linkStyles = {
		...currentPageStyles,
		cursor: 'pointer',
	};

	const breadcrumbs = CurrentPageIcon
		? [
				<Link
					underline='hover'
					color='text.secondary'
					onClick={() => history.push(PAGE_ROUTES.HOME)}
					sx={{ ...linkStyles }}
					key={`${BEM_NAME_ELEMENTS.VIEW_BREADCRUMBS}__${BEM_NAME_ELEMENTS.FIELD_LINK}--uar-home`}
					id={`${BEM_NAME_ELEMENTS.VIEW_BREADCRUMBS}__${BEM_NAME_ELEMENTS.FIELD_LINK}--uar-home`}
				>
					<PAGE_ICONS.HOME sx={{ mr: 0.5 }} fontSize='inherit' />
					New Non-Employee
				</Link>,
				<Typography
					color='text.primary'
					sx={{ ...currentPageStyles }}
					key={`${BEM_NAME_ELEMENTS.VIEW_BREADCRUMBS}__${BEM_NAME_ELEMENTS.FIELD_LINK}--current-page`}
					id={`${BEM_NAME_ELEMENTS.VIEW_BREADCRUMBS}__${BEM_NAME_ELEMENTS.FIELD_LINK}--current-page`}
				>
					<CurrentPageIcon sx={{ mr: 0.5 }} fontSize='inherit' />
					{currentPageLabel}
				</Typography>,
		  ]
		: [
				[
					<Typography
						color='text.primary'
						sx={{ ...currentPageStyles }}
						key={`${BEM_NAME_ELEMENTS.VIEW_BREADCRUMBS}__${BEM_NAME_ELEMENTS.FIELD_LINK}--uar-home`}
						id={`${BEM_NAME_ELEMENTS.VIEW_BREADCRUMBS}__${BEM_NAME_ELEMENTS.FIELD_LINK}--uar-home`}
					>
						<PAGE_ICONS.HOME sx={{ mr: 0.5 }} fontSize='inherit' />
						New Non-Employee
					</Typography>,
				],
		  ];

	return (
		<PageWithBreadcrumbs breadcrumbs={[...breadcrumbs]}>
			{props.children}
		</PageWithBreadcrumbs>
	);
};

NEPageWithBreadcrumbs.propTypes = {
	currentPageLabel: PropTypes.string,
	CurrentPageIcon: PropTypes.object,
	children: PropTypes.node,
};

export default NEPageWithBreadcrumbs;
